export const GENERAL_EMPLOYER = "GENERAL_EMPLOYER";
export const GENERAL_FUTURE_EXPENSES_TABLE = "GENERAL_FUTURE_EXPENSES_TABLE";
export const RESET_GENERAL = "RESET_GENERAL";
export const GENERAL_EMPLOYER_NEW = "GENERAL_EMPLOYER_NEW";
